export default "__VITE_ASSET__bpnpSMjL__"